import Vue from "vue";
import App from "./App.vue";
import VueScrollTo from "vue-scrollto";
import BootstrapVue from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import AOS from "aos";
import "aos/dist/aos.css";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import axios from "axios";
import router from "./router/index.js";
import { detect } from "detect-browser";
import store from "./store";
import VueHtmlToPaper from "vue-html-to-paper";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { mapActions } from "vuex";

library.add(faSpinner);
Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.config.productionTip = false;

Vue.use(VueScrollTo, {
  container: "body",
  duration: 500,
  easing: "ease",
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true,
});

const options = {
  name: "_blank",
  specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
};

Vue.use(BootstrapVue);

Vue.use(VueSweetalert2);

Vue.use(VueHtmlToPaper, options);

new Vue({
  store,
  methods: {
    ...mapActions(["fetchUserInfo", "fetchEpitch"]),
  },
  created() {
    this.fetchUserInfo();
    this.fetchEpitch();
    AOS.init();
  },
  router,
  render: (h) => h(App),
}).$mount("#app");
